import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { SigninComponent } from './signin/signin.component';
import { ForgotComponent } from './forgot/forgot.component';

import { AuthenticationService } from './authentication.service';

import { FormsModule } from '@angular/forms';
import { SignoutComponent } from './signout/signout.component';
import { AuthenticationInterceptor } from './authentication-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientXsrfModule, HttpXsrfTokenExtractor } from '@angular/common/http';
import { HttpModule, CookieXSRFStrategy, XSRFStrategy } from '@angular/http';

@NgModule({
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    FormsModule,
    HttpClientModule,
    HttpModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN',
    }),
  ],
  providers: [
    HttpClientModule,
    AuthenticationService,
    AuthenticationInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
    { provide: XSRFStrategy, useValue: cookieStrategy },
  ],
  declarations: [SigninComponent, ForgotComponent, SignoutComponent]
})
export class AuthenticationModule { }

export function cookieStrategy() {
  return  new CookieXSRFStrategy('csrftoken', 'X-CSRFToken');
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/authentication/authentication.module.ts